import { api } from '@marine/api-client/api';

/**
 * Platform-wide per-feature AI defaults (Phase 39.2).
 *
 * Server shape:
 *   GET /api/ai/feature-configs          → PlatformAiFeatureConfig[]
 *   PUT /api/ai/feature-configs/{feature} → PlatformAiFeatureConfig
 *
 * `api.getList` / `api.putOne` already unwrap the `{data: ...}` envelope;
 * these signatures do NOT need a `select: (r) => r.data` step on top
 * (memory rule `feedback_api_envelope_unwrap.md`).
 */
export interface PlatformAiFeatureConfig {
  feature:     string;
  model:       string | null;
  temperature: number | null;
  max_tokens:  number | null;
  updated_at:  string | null;
  updated_by:  string | null;
}

export interface UpdatePlatformAiFeatureConfigInput {
  model?:       string | null;
  temperature?: number | null;
  max_tokens?:  number | null;
}

export const aiFeatureConfigsApi = {
  list: (): Promise<PlatformAiFeatureConfig[]> =>
    api.getList<PlatformAiFeatureConfig>('/api/ai/feature-configs'),

  update: (
    feature: string,
    input:   UpdatePlatformAiFeatureConfigInput,
  ): Promise<PlatformAiFeatureConfig> =>
    api.putOne<PlatformAiFeatureConfig>(
      `/api/ai/feature-configs/${encodeURIComponent(feature)}`,
      input,
    ),
};
